var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-browser-card photo-browser-card--ph j-media"},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Drop here")])])}
var staticRenderFns = []

export { render, staticRenderFns }